import { GaussianViewer, type GaussianViewerProps } from "./GaussianViewer";
export type SPZViewerProps = GaussianViewerProps;
export function SPZViewer(props: SPZViewerProps) {
	return <GaussianViewer format="spz" {...props} />;
}
